import { IsString, IsUUID } from 'class-validator';

export class UpdateChatMessageReactionDto {
	@IsUUID()
	id: string;

	@IsString()
	emoji: string;
}
